/* eslint-disable import/no-anonymous-default-export */
import MonthlyProgressActionTypes from './monthly-progress.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getMonthlyProgressListResponse: null,
	getMonthlyProgressListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_SUCCESS:
			return {
				...state,
				getMonthlyProgressListResponse: action.payload,
				getMonthlyProgressListArr: docodeHexResponse(
					action.payload,
					'GetMonthlyReportProgressKey',
				),
			};

		case MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_FAILURE:
			return { ...state, getMonthlyProgressListResponse: action.payload };

		case MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_RESPONSE_CHANGED:
			return { ...state, getMonthlyProgressListResponse: null };
		default:
			return state;
	}
};
